export default {
  title: "Ballarni hisoblash",
  toSetDiffPercent:
    "Mijozlarning xarid summasiga qarab turli mukofot foizlarini belgilash uchun «Promo» yoki «Pro+» tarifini sotib olish kerak",
  areUSureToDeleteGroup: "Haqiqatan ham guruhni oʻchirib tashlamoqchimisiz?",
  userGetAwardDuring30Min:
    "Foydalanuvchi operatsiya amalga oshirilganidan keyin 30 daqiqa ichida mukofotni oladi",
  creatingNewAndEditingNotAvailable:
    "Yangi guruh yaratish va mavjudlarini tahrirlash hozircha mavjud emas",
  payAttention: "Diqqat qiling!",
  bannerText:
    "Bu funksiya faqat siz raqamlashtirgan mijozlar uchun ishlaydi. <br /><br /> Sizning <b>raqamlashtirilgan</b> mijozlaringiz guruhda koʻrsatilgan foizning 50% qismini mukofot sifatida oladilar (komissiya olinmaydi). Xarid summasi chegirma summasisiz hisoblanadi.",
  seeRewardScenarios: "Mukofotni taqsimlash ssenariylarini koʻrish",
  createNewGroup: "Yangi guruh yaratish",

  tableHeaders: {
    groupNaming: "Guruh<br/>nomi",
    pointNaming: "Savdo<br/>nuqtasi nomi",
    purchaseSum: "Xarid<br/>summasi",
    accrualPercent: "Hisoblash<br/>foizi",
    status: "Holat",
  },
};
